'use client'

import { useStateStore } from "@/context/stateStore";
import { CycleDate, CycleFormType, CycleStage, CycleStatus, PlantForCycle } from "./cycleFields/cycleFields";

export default function CycleFields({ cycleForm }: { cycleForm: CycleFormType }) {

    const plants = useStateStore(state => state.plants);
    const height = useStateStore(state => state.heightQuery);

    return (
        <section className="flex flex-col justify-start items-center space-y-8 w-full h-full p-2 md:p-4 bg-green-700/30 rounded-md shadow-lg">
            <span className="flex flex-row justify-between items-center w-full">
                <CycleDate cycleForm={cycleForm} />
                <p className="text-[12px] w-[60px] h-[60px] border border-black text-center w-content align-end">{`"Future Pic Space"`}</p>
            </span>
            <PlantForCycle cycleForm={cycleForm} plants={plants} heightQuery={height} />
            <CycleStatus cycleForm={cycleForm} heightQuery={height} />
            <CycleStage cycleForm={cycleForm} heightQuery={height} />
        </section>
    )
}
